var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.to)?_c('div',{staticClass:"grid"},[(_vm.isExternalLink)?_c('a',{staticClass:"grid",attrs:{"href":_vm.to,"target":"_blank"}},[_vm._t("default")],2):_c('nuxt-link',{staticClass:"grid",attrs:{"to":_vm.to}},[_vm._t("default")],2)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }